export const NOTIFICATION_MAP = {
  PriceCreated: {
    text1: " created a new price: ",
    text2: "waiting for approval.",
    key: "name",
    link: () => "/price-management/prices",
  },
  PriceUpdated: {
    text1: " updated the price: ",
    text2: "waiting for approval.",
    key: "name",
    link: () => "/price-management/prices",
  },
  PriceApproved: {
    text1: " as reviewed price ",
    text2: "and approved it.",
    key: "name",
    link: () => "/price-management/prices",
  },
  PriceDeclined: {
    text1: " has reviewed price ",
    text2: "and declined it.",
    key: "name",
    link: () => "/price-management/prices",
  },
  PriceExpired: {
    text1: "",
    text2: " price is expired. End Time is reached before approval.",
    key: "name",
    link: () => "/price-management/prices",
  },
  BundleCreated: {
    text1: " created a new bundle: ",
    text2: "waiting for approval.",
    key: "name",
    link: id => `/price-management/bundles/${id}`,
  },
  BundleUpdated: {
    text1: " updated the bundle: ",
    text2: "waiting for approval.",
    key: "name",
    link: id => `/price-management/bundles/${id}`,
  },
  BundleApproved: {
    text1: " has reviewed bundle ",
    text2: "and approved it.",
    key: "name",
    link: id => `/price-management/bundles/${id}`,
  },
  BundleDeclined: {
    text1: " has reviewed bundle ",
    text2: "and declined it.",
    key: "name",
    link: id => `/price-management/bundles/${id}`,
  },
  BundleExpired: {
    text1: "",
    text2: " bundle is expired. End Time is reached before approval.",
    key: "name",
    link: id => `/price-management/bundles/${id}`,
  },
  BundleAssignmentCreated: {
    text1: " created a new bundle assignment: ",
    text2: "waiting for approval. ",
    key: "id",
    link: id => `/price-management/bundles/${id}`,
  },
  BundleAssignmentApproved: {
    text1: " has reviewed bundle assignment ",
    text2: "and approved it.",
    key: "id",
    link: id => `/price-management/bundles/${id}`,
  },
  BundleAssignmentDeclined: {
    text1: " has reviewed bundle assignment ",
    text2: "and declined it.",
    key: "id",
    link: id => `/price-management/bundles/${id}`,
  },
};
